<template>
    <div class="newsletter-signup">
        <div class="newsletter-signup__wrapper">
            <slot name="header"></slot>
            <slot name="text"></slot>
            <div class="newsletter-signup__fields" v-if="status <= 0">
                <input-field icon-type="user" :name="translations.name_field" :error="validation.name" :value="form.name" @input="(val) => $set(form, 'name', val)"></input-field>
                <input-field icon-type="email" :name="translations.email_field" :error="validation.email" :value="form.email" @input="(val) => $set(form, 'email', val)"></input-field>
            </div>
            <div class="newsletter-signup__ebook">
                <div class="newsletter-signup__ebook__image"></div>
                <slot name="ebook-text"></slot>
            </div>
            <p v-if="status == 1" v-text="translations.success_msg" class="mail-msg mail-msg--success"></p>
            <p v-if="status == -1" v-text="translations.fail_msg" class="mail-msg mail-msg--error"></p>
            <button v-if="status <= 0" class="btn newsletter-signup__btn" :class="{'loading': loading}" v-text="translations.signup_btn" :disabled="validationErrors" @click="subscribe"></button>
        </div>
    </div>
</template>

<script type="text/javascript">
    import InputField from '../input-field.vue';
    import Validate from 'validate.js';
    import API from '../../skovapi.js';

    export default {
        props: {
            interests: {type: String, default: 'All'}
        },
        data() {
            return {
                translations: APP_CONFIG.TRANSLATION.NEWSLETTER_SIGNUP,
                validation: { },
                loading: false,
                status: 0,
                form: {
                    name: '',
                    email: ''
                }           
            }
        },
        methods: {
            subscribe() {
                if(this.loading)
                    return;

                this.validation = { };
                let errors = this.validationErrors;
                if(errors) {
                    this.validation = Object.assign({}, errors);
                    return;
                }
                
                this.loading = true;
                API.signupToNewsletter(this.firstName, this.lastName, this.form.email, this.interests).then((res) => {
                    this.status = 1;
                    this.loading = false;
                    this.form = {
                        name: '',
                        email: ''
                    }
                }).catch((error) => {
                    console.error(error);
                    this.status = -1;
                    this.loading = false;
                });
            }
        },
        computed: {
            firstName() {
                return this.form.name.split(' ', 1)[0];
            },
            lastName() {
                let nameParts = this.form.name.split(' ');
                nameParts.shift();
                return (nameParts.length > 0) ? nameParts.join(' ') : '';
            },
            validationErrors() {
                let errors = Validate(this.form, {
                    name: {
                        presence: {
                            allowEmpty: false,
                            message: this.translations.ERRORS.name_field
                        }
                    },
                    email: {
                        presence: {
                            allowEmpty: false,
                            message: this.translations.ERRORS.email_field
                        },
                        email: {
                            message: this.translations.ERRORS.email_not_valid
                        }
                    }
                }, {
                    fullMessages: false
                });

                return (errors) ? errors : null;
            }
        },
        components: {
            'input-field': InputField
        }
    }
</script>